import { Box, Drawer, Button, IconButton, Divider } from '@mui/material';
import { Link } from 'react-router-dom';
import useNotification from 'src/hooks/useNotifications';
import NotificationsBody from './NotificationsBody';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CloseIcon from '@mui/icons-material/Close';
import 'src/theme/partials/notifications/NotificationsBase.css';
import 'src/theme/partials/notifications/NotificationsDrawer.css';
import { FC, memo } from 'react';

const NotificationsDrawer: FC<React.PropsWithChildren> = () => {
  const { closeNotificationDrawer, isNotificationDrawerOpen, tasksInNotificationRange } = useNotification();

  return (
    <Drawer anchor="right" open={isNotificationDrawerOpen} onClose={() => closeNotificationDrawer()}>
      <Box className="notification-drawer">
        <div className="notification-drawer__header">
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <NotificationsIcon />
            <h3>({tasksInNotificationRange.length && `${tasksInNotificationRange.length}`}) Upcoming Tasks</h3>
          </Box>
          <IconButton onClick={() => closeNotificationDrawer()}>
            <CloseIcon />
          </IconButton>
        </div>

        <div className="notification-drawer__body">
          <NotificationsBody showUpcomingTasks={true} />
        </div>

        <div className="notification-drawer__footer notifications__btns">
          <Button color="primary" variant="text" onClick={() => closeNotificationDrawer()}>
            <Link to="/activity/Tasks">View all Tasks</Link>
          </Button>
          <Divider orientation="vertical" flexItem variant="middle" />
          <Button color="primary" variant="text" onClick={() => closeNotificationDrawer()}>
            <Link to="/account/settings">Notification Settings</Link>
          </Button>
        </div>
      </Box>
    </Drawer>
  );
};

export default memo(NotificationsDrawer);
